import React from 'react'

import './Footer.scss'

export default () => {
  const currentYear = new Date().getFullYear()
  return (
    <div className="footer text-center">
      <span className="mr-4">Mentions legales</span> &copy; {currentYear} Banoi
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js